/** 租户详情-设备 Tab（TenantDevices.vue） */
export default {
  tenantDevicesPage: {
    cardElectric: '智能电表',
    cardWater: '智能水表',
    cardAir: '空调',
    cardLighting: '照明',
    cardDoorlock: '智能门锁',
    cardStatsDedicatedGroups: '专用 {dedicated} 公摊组 {groups}',
    cardLightingStats: '灯组 -- 灯 --',
    cardDoorlockPlaceholder: '--',
    sectionDedicatedElectric: '专用电表',
    sectionDedicatedWater: '专用水表',
    sectionDedicatedAir: '专用空调',
    sectionShareGroup: '公摊组',
    btnBindUnbindElectric: '绑定/解绑电表',
    btnBindUnbindWater: '绑定/解绑水表',
    btnBindUnbindAir: '绑定/解绑空调',
    btnBindUnbindShare: '绑定/解绑公摊组',
    colSerial: '序列号',
    colDeviceName: '设备名称',
    colType: '类型',
    colPayMode: '付费模式',
    colSwitchState: '分合闸状态',
    colOnline: '在线状态',
    colLastDataTime: '最新数据时间',
    colActions: '操作',
    colWaterPrice: '水价',
    colSettleMode: '结算方式',
    colBindTime: '绑定时间',
    colShareGroupId: '公摊组编号',
    colShareGroupName: '公摊组名称',
    colShareMethod: '公摊方式',
    colShareDevices: '公摊设备',
    colShareTenants: '公摊租户',
    colUpdatedAt: '更新时间',
    colCreatedAt: '创建时间',
    colShareArea: '公摊面积',
    colActualShareArea: '实际公摊面积',
    colPowerState: '开关状态',
    colRunMode: '运行模式',
    colTargetTemp: '设定温度',
    colRoomTemp: '室内温度',
    tagDedicated: '专用',
    tagShared: '公摊',
    tagPrepaid: '预付费',
    tagForceControl: '强控',
    switchOn: '合闸',
    switchOff: '分闸',
    online: '在线',
    offline: '离线',
    powerOn: '开启',
    powerOff: '关闭',
    settleAdd: '+ 加算',
    settleSubtract: '- 减算',
    waterBindDedicated: '专用表',
    waterBindShared: '公摊表',
    waterBindFormula: '公式表',
    noPrice: '未设置价格',
    btnDetail: '详情',
    emptyNotOpen: '暂未开放',
    drawerBoundMeters: '已绑定电表',
    drawerSelectableMeters: '可选电表',
    drawerBoundShares: '已绑定公摊组',
    drawerSelectableShares: '可选公摊组',
    drawerBoundWaters: '已绑定水表',
    drawerSelectableWaters: '可选水表',
    drawerBoundWaterShares: '已绑定水表公摊组',
    drawerSelectableWaterShares: '可选水表公摊组',
    drawerBoundAirs: '已绑定空调',
    drawerSelectableAirs: '可选空调',
    drawerBoundAirShares: '已绑定公摊组',
    drawerSelectableAirShares: '可选公摊组',
    phSearchMeter: '请输入电表名称或序列号搜索',
    phSearchWater: '请输入水表名称或序列号搜索',
    phSearchAir: '请输入空调名称或序列号搜索',
    phSearchShare: '请输入公摊组名称搜索',
    labelSerialShort: '序列号:',
    labelArea: '面积:',
    labelShareArea: '公摊面积:',
    labelSettleMode: '结算方式:',
    labelCreatedAt: '创建时间:',
    phInput: '请输入',
    phSelect: '选择',
    btnBind: '绑定',
    btnUnbind: '解绑',
    emptyNoBoundMeters: '暂无已绑定的电表',
    emptyNoSelectableMeters: '暂无可绑定的电表',
    emptyNoBoundShares: '暂无已绑定的公摊组',
    emptyNoSelectableShares: '暂无可绑定的公摊组',
    emptyNoBoundWaters: '暂无已绑定的水表',
    emptyNoSelectableWaters: '暂无可绑定的水表',
    emptyNoBoundWaterShares: '暂无已绑定的水表公摊组',
    emptyNoSelectableWaterShares: '暂无可绑定的水表公摊组',
    emptyNoBoundAirs: '暂无已绑定的空调',
    emptyNoSelectableAirs: '暂无可绑定的空调',
    emptyNoBoundAirShares: '暂无已绑定的公摊组',
    emptyNoSelectableAirShares: '暂无可绑定的公摊组',
    dialogDrawerElectric: '电表关联/解绑',
    dialogDrawerElectricGroup: '电表公摊组关联/解绑',
    dialogDrawerWater: '水表关联/解绑',
    dialogDrawerWaterGroup: '水表公摊组关联/解绑',
    dialogDrawerAir: '空调关联/解绑',
    dialogDrawerAirGroup: '空调公摊组关联/解绑',
    dialogDrawerDefault: '关联设备',
    switchDialogMeter: '电表',
    switchDialogAction: '操作',
    switchDialogPhone: '绑定手机',
    switchDialogCode: '验证码',
    phSmsCode: '请输入验证码',
    sendSms: '发送验证码',
    smsCountdown: '{seconds}秒',
    copyHint: '点击复制',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    airEditTitle: '编辑空调',
    labelDeviceName: '设备名称',
    labelDeviceType: '设备类型',
    labelShareBindType: '公摊类型',
    labelRemark: '备注',
    phDeviceName: '请输入设备名称',
    phDeviceType: '请选择设备类型',
    phShareBindType: '请选择公摊类型',
    phRemark: '请输入备注',
    airTypeVrf: '多联机',
    shareTypeArea: '面积占比',
    shareTypeEnergy: '能耗占比',
    shareTypeUnknown: '未知',
    airModeAuto: '自动',
    airModeHeat: '制热',
    airModeCool: '制冷',
    airModeFan: '送风',
    airModeDry: '除湿',
    fanAuto: '自动',
    fanLow: '低风',
    fanMid: '中风',
    fanHigh: '高风',
    airTypeUnknown: '未知',
    switchVerifyTitleDefault: '分合闸操作验证',
    switchVerifyTitleSuffix: '操作验证',
    titleTip: '提示',
    btnOk: '确定',
    btnCancelPlain: '取消',
    msgFeatureNotOpen: '该功能暂未开放',
    msgLoadFail: '加载数据失败，请重试',
    msgNoBindPerm: '暂无绑定权限',
    msgEditOk: '编辑成功',
    msgEditFail: '编辑失败',
    msgNothingToCopy: '无可复制内容',
    msgSerialCopied: '序列号已复制',
    msgCopyFail: '复制失败',
    msgFetchElectricFail: '获取专用电表列表失败',
    msgFetchElectricGroupFail: '获取电表公摊组列表失败',
    msgNoSwitchPerm: '暂无分合闸权限',
    confirmPrepaidToForceBody: '该电表为预付费模式，需要先修改为强控模式才能进行分合闸操作。是否立即修改？',
    msgPayModeOk: '付费模式修改成功',
    msgPayModeFail: '修改付费模式失败',
    msgNoPhone: '未获取到绑定手机号',
    msgSmsSent: '验证码已发送',
    msgSmsSendFail: '发送验证码失败',
    msgEnterCode: '请输入验证码',
    confirmSwitchBody: '确定要对电表「{name}」执行{action}操作吗？',
    msgSwitchOk: '{action}操作成功',
    msgSwitchFail: '{action}操作失败',
    msgFetchWaterFail: '获取专用水表列表失败',
    msgFetchWaterGroupFail: '获取水表公摊组列表失败',
    msgFetchAirFail: '获取专用空调列表失败',
    msgFetchAirGroupFail: '获取空调公摊组列表失败',
    msgFetchMeterBindFail: '获取电表绑定数据失败',
    msgBindOk: '绑定成功',
    msgBindFail: '绑定失败',
    msgBindMeterFail: '绑定电表失败',
    confirmUnbindMeter: '确定要解绑电表 {name} 吗？',
    msgUnbindOk: '解绑成功',
    msgUnbindFail: '解绑失败',
    msgUnbindMeterFail: '解绑电表失败',
    msgFetchShareBindFail: '获取公摊组绑定数据失败',
    msgInvalidShareArea: '请输入有效的公摊面积',
    msgBindShareFail: '绑定公摊组失败',
    confirmUnbindShare: '确定要解绑公摊组 {name} 吗？',
    msgUnbindShareFail: '解绑公摊组失败',
    msgFetchWaterBindFail: '获取水表绑定数据失败',
    msgBindWaterFail: '绑定水表失败',
    confirmUnbindWater: '确定要解绑水表 {name} 吗？',
    msgUnbindWaterFail: '解绑水表失败',
    msgFetchWaterShareBindFail: '获取水表公摊组绑定数据失败',
    msgBindWaterShareFail: '绑定水表公摊组失败',
    confirmUnbindWaterShare: '确定要解绑水表公摊组 {name} 吗？',
    msgUnbindWaterShareFail: '解绑水表公摊组失败',
    msgFetchAirBindFail: '获取空调绑定数据失败',
    msgBindAirFail: '绑定空调失败',
    confirmUnbindAir: '确定要解绑空调 {name} 吗？',
    msgUnbindAirFail: '解绑空调失败',
    msgFetchAirShareBindFail: '获取空调公摊组绑定数据失败',
    msgBindAirShareFail: '绑定空调公摊组失败',
    confirmUnbindAirShare: '确定要解绑空调公摊组 {name} 吗？',
    msgUnbindAirShareFail: '解绑空调公摊组失败'
  }
}
